/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_skalpell': {
    width: 32,
    height: 31,
    viewBox: '0 0 32 31',
    data: '<path pid="0" d="M16.5 15.5l-15 15c3.314 0 6.314-1.343 8.485-3.515L13 24l-1-1 2-2m13.672-3.672A2 2 0 0 0 30.5 14.5l-.672-.671m-2.156 3.5a2 2 0 0 1-2.829 2.828l-.671-.672m3.5-2.157L27 16.657M31.5.5v7.757a3 3 0 0 1-.879 2.122L19.75 21.25a1.768 1.768 0 1 1-2.5-2.5l5.25-5.25h-7l-7.684 7.684a1.86 1.86 0 0 1-2.762-2.486l7.18-8.87a3 3 0 0 1 .612-.57l8.374-5.862A3 3 0 0 0 22.5.938V.5h9z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_skalpell.js